import axios from 'axios';
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

const apiScope = ["api://ea66ff46-9e2f-4425-a724-240432c3e9db/access_as_user"];

export const useApiService = () => {
    const { instance, accounts } = useMsal();

    const acquireToken = async () => {
        const request = {
            scopes: apiScope,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await instance.acquireTokenRedirect(request);
            } else {
                console.log("Token acquisition error:", error);
                throw error;
            }
        }
    };

    const handleApiRequest = async (url, method = "GET", body = null) => {
        try {
            const token = await acquireToken();
            const isFormData = body instanceof FormData;

            const headers = {
                "Authorization": `Bearer ${token}`,
                'content-type': isFormData ? 'multipart/form-data' : "application/json",
            }

            const response = await axios({
                method: method.toLowerCase(),
                url: url,
                headers: headers,
                ...(body && { data: body }),
            })

            return response.data;
        } catch (error) {
            console.log("API request failed:", error);
            throw error;
        }
    };

    return handleApiRequest;
};

